export const ADVISOR_PROSPECTS_RECEIVED = 'ADVISOR_PROSPECTS_RECEIVED' 
export const ADVISOR_PROSPECTS_UPDATED = 'ADVISOR_PROSPECTS_UPDATED'
export const ADVISOR_PROSPECTS_DELETED = 'ADVISOR_PROSPECTS_DELETED'
export const ADVISOR_PROSPECT_NOTE_UPDATED = 'ADVISOR_PROSPECT_NOTE_UPDATED'
export const ADVISOR_PROSPECT_STATUS_UPDATED = 'ADVISOR_PROSPECT_STATUS_UPDATED'
